export class QueryDBRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "destinationType",
            "baseName": "destinationType",
            "type": "QueryDBRestoreDestinationType",
            "format": ""
        },
        {
            "name": "s3Bucket",
            "baseName": "s3Bucket",
            "type": "S3RestoreDestination",
            "format": ""
        },
        {
            "name": "gcsBucket",
            "baseName": "gcsBucket",
            "type": "GCSRestoreDestination",
            "format": ""
        },
        {
            "name": "storageAccount",
            "baseName": "storageAccount",
            "type": "StorageAccountContainerRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QueryDBRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
